import { render } from "./SalesDetails.vue?vue&type=template&id=5f710c7b&scoped=true&ts=true"
import script from "./SalesDetails.vue?vue&type=script&lang=ts"
export * from "./SalesDetails.vue?vue&type=script&lang=ts"

import "./SalesDetails.vue?vue&type=style&index=0&id=5f710c7b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f710c7b"]])

export default __exports__